import { DeleteOutlined } from '@ant-design/icons'
import { useMutation } from '@apollo/client/react'
import { Button, notification, Popconfirm } from 'antd'
import i18n from '~app/i18n/i18n'
import {
  DeleteDocumentDocument,
  DocumentStage,
  UnassignDocumentDocument,
} from '../graph/generated/graphql'

notification.config({ placement: 'bottomRight' })

interface Props {
  documentId: string
  documentStage: DocumentStage
  onDone?: () => any
}

const RemoveCustomerDocumentButton = ({
  documentId,
  documentStage,
  onDone,
}: Props) => {
  const [deleteDocument, { loading }] = useMutation(DeleteDocumentDocument)
  const [unassignDocument, { loading: loadingUnassignCall }] = useMutation(
    UnassignDocumentDocument
  )
  return (
    <Popconfirm
      title={i18n.t('misc.confirmationDialog.title')}
      okText={i18n.t('misc.confirmationDialog.okText')}
      cancelText={i18n.t('misc.confirmationDialog.cancelText')}
      placement="bottomLeft"
      onConfirm={async () => {
        try {
          const result =
            documentStage === DocumentStage.ManualProcessingStarted
              ? await unassignDocument({
                  variables: {
                    id: documentId,
                  },
                })
              : await deleteDocument({
                  variables: {
                    id: documentId,
                  },
                })
          if (result && result.error) {
            const error = result.error
            notification.error({
              message: i18n.t('deleteDocuments.errorDeletingDocument'),
              description: error.message,
            })
          } else {
            notification.success({
              message: i18n.t('misc.success'),
              description: i18n.t(
                'deleteDocuments.documentDeletedSuccessfully',
                { documentId }
              ),
            })
            if (onDone) {
              onDone()
            }
          }
        } catch (error) {
          notification.error({
            message: i18n.t('deleteDocuments.errorDeletingDocument'),
            description:
              (error as any).message ||
              i18n.t('deleteDocuments.errorMessageFatal'),
          })
        }
      }}
    >
      <Button
        type="primary"
        danger
        size="small"
        disabled={loading || loadingUnassignCall}
        icon={<DeleteOutlined />}
      >
        {i18n.t('deleteDocuments.removeDocument')}
      </Button>
    </Popconfirm>
  )
}

export { RemoveCustomerDocumentButton }
